// Class: openfl.display._internal._Context3DGraphics.PolygonFunctions

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;
var $import = require("./../../../../import_stub").default;
function Std() {return require("./../../../../Std");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../../../openfl/_Vector/Vector_Impl_");}

// Constructor

var PolygonFunctions = function(){}

// Meta

PolygonFunctions.__name__ = "openfl.display._internal._Context3DGraphics.PolygonFunctions";
PolygonFunctions.__isInterface__ = false;
PolygonFunctions.prototype = {
	
};
PolygonFunctions.prototype.__class__ = PolygonFunctions.prototype.constructor = $hxClasses["openfl.display._internal._Context3DGraphics.PolygonFunctions"] = PolygonFunctions;

// Init



// Statics

PolygonFunctions.getEllipseNumVertices = function(radiusX,radiusY) {
	var numVertices = (Std().default).int(Math.PI * (radiusX + radiusY) / 4.0);
	if(numVertices < 6) {
		numVertices = 6;
	}
	return numVertices;
}
PolygonFunctions.buildEllipseVerticesAndIndices = function(x,y,radiusX,radiusY,scaleX,scaleY,vertices,indices) {
	var numVertices = PolygonFunctions.getEllipseNumVertices(radiusX * scaleX,radiusY * scaleY);
	var angleDelta = 2.0 * Math.PI / numVertices;
	var angle = 0.0;
	vertices.set_length(numVertices * 2);
	var _g = 0;
	var _g1 = numVertices;
	while(_g < _g1) {
		var i = _g++;
		(openfl__$Vector_Vector_$Impl_$().default).set(vertices,i * 2,Math.cos(angle) * radiusX + x + radiusX);
		(openfl__$Vector_Vector_$Impl_$().default).set(vertices,i * 2 + 1,Math.sin(angle) * radiusY + y + radiusY);
		angle += angleDelta;
	}
	indices.set_length((numVertices - 2) * 3);
	var from = 0;
	var to = numVertices - 2;
	var _g2 = from;
	var _g3 = to;
	while(_g2 < _g3) {
		var i1 = _g2++;
		(openfl__$Vector_Vector_$Impl_$().default).set(indices,i1 * 3,0);
		(openfl__$Vector_Vector_$Impl_$().default).set(indices,i1 * 3 + 1,i1 + 1);
		(openfl__$Vector_Vector_$Impl_$().default).set(indices,i1 * 3 + 2,i1 + 2);
	}
}
PolygonFunctions.getRoundRectNumVertices = function(radiusX,radiusY) {
	var numVerticesPerCorner = Math.ceil(Math.PI * (radiusX + radiusY) / 8.0);
	if(numVerticesPerCorner < 3) {
		numVerticesPerCorner = 3;
	}
	return numVerticesPerCorner * 4;
}
PolygonFunctions.buildRoundRectVerticesAndIndices = function(x,y,width,height,radiusX,radiusY,scaleX,scaleY,vertices,indices) {
	var numVertices = PolygonFunctions.getRoundRectNumVertices(radiusX * scaleX,radiusY * scaleY);
	var verticesPerCorner = (Std().default).int(numVertices / 4);
	var angleDelta = Math.PI / 2.0 / (verticesPerCorner - 1);
	var angle = 0.0;
	var offsetX = width - radiusX - radiusX;
	var offsetY = height - radiusY - radiusY;
	var horizontal = true;
	vertices.set_length(numVertices * 2);
	var j = 0;
	var len = verticesPerCorner;
	var _g = 0;
	while(_g < 4) {
		var i = _g++;
		while(j < len) {
			(openfl__$Vector_Vector_$Impl_$().default).set(vertices,j * 2,offsetX + Math.cos(angle) * radiusX + x + radiusX);
			(openfl__$Vector_Vector_$Impl_$().default).set(vertices,j * 2 + 1,offsetY + Math.sin(angle) * radiusY + y + radiusY);
			angle += angleDelta;
			++j;
		}
		angle -= angleDelta;
		if(horizontal) {
			if(offsetX == 0.0) {
				offsetX = width - radiusX - radiusX;
			} else {
				offsetX = 0.0;
			}
		} else if(offsetY == 0.0) {
			offsetY = height - radiusY - radiusY;
		} else {
			offsetY = 0.0;
		}
		horizontal = !horizontal;
		len += verticesPerCorner;
	}
	indices.set_length((numVertices - 2) * 3);
	var from = 0;
	var to = numVertices - 2;
	var _g1 = from;
	var _g2 = to;
	while(_g1 < _g2) {
		var i1 = _g1++;
		(openfl__$Vector_Vector_$Impl_$().default).set(indices,i1 * 3,0);
		(openfl__$Vector_Vector_$Impl_$().default).set(indices,i1 * 3 + 1,i1 + 1);
		(openfl__$Vector_Vector_$Impl_$().default).set(indices,i1 * 3 + 2,i1 + 2);
	}
}


// Export

exports.default = PolygonFunctions;